import React, { Component} from 'react';
import { Col, Container, Row,Card,CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { getCompany } from '../../store/actions/initialState';

class Confirmed extends Component {

	render(){
		return <div className="app flex-row align-items-center">
			<Container>
				<Row className="justify-content-center">
					<Col md="5">
						<Card className="p-4 text-center">
							<CardBody>
								<img
								style={{display:'block',margin:'0 auto',maxWidth: '100%',height: '90px'}}
								ref={ `provider-img`}
								src={  this.props.company && this.props.company.styles_json && this.props.company.styles_json.styles && this.props.company.styles_json.styles.company_logo ? this.props.company.styles_json.styles.company_logo : '/assets/img/logo-default-180x64.svg' }
								onError={ ()=>this.refs[`provider-img`].src= '/assets/img/logo-default-180x64.svg' }
							alt={  "" } />
								<img  src={ '/assets/img/congratulation.svg' } alt={ 'confirmed' } style={{width:"220px",maxWidth:'100%'}}/>
								<h3><b>Felicitaciones!<br/> tus datos han sido confirmados</b></h3>

							</CardBody>
							<div className="text-center">
								<Button
									color="primary"
									onClick={() => window.location.href = 'https://play.google.com/store/apps/details?id=io.dondemand.provider.zupper'}
									>
									<i className="fa fa-google" /> Descargar en PlayStore
								</Button>
							</div>
						</Card>
					</Col>
				</Row>
			</Container>
		</div>
	}
}
const mapStateToProps = (state) => {
	return {
		errors: state.errors,
		company: state.company,
		json_lang: state.json_lang,
		accountType:state.accountType

	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getCompany: () => dispatch(getCompany()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmed);



// WEBPACK FOOTER //
// ./src/views/Register/Confirmed.jsx